<template>
  <div class="list-card" @click="navigateToPersonalTaskList" @mouseenter="isListOptionsButtonShown = true"
       @mouseleave="isListOptionsButtonShown = false">
    <b-row>
      <b-col>
        <p class="list-name-text">{{ listDetails.toDoListName }}</p>
        <p v-if="listDetails.toDoListDescription" class="list-description-text">{{ listDetails.toDoListDescription
          }}</p>
        <p v-else class="list-description-text">No description provided.</p>
      </b-col>
      <b-col class="col-1 mr-2 center-align-icon">
        <font-awesome-icon v-if="isListOptionsButtonShown" class="task-option-button mt-1" :icon="['far', 'edit']"
                           @click.stop="isEditListDetailsModalShown = true"/>
        <font-awesome-icon v-if="isListOptionsButtonShown" class="task-option-button mt-3" :icon="['far', 'trash-alt']"
                           @click.stop="isDeleteListModalShown = true"/>
      </b-col>
    </b-row>

    <!-- List Options Modal -->
    <b-modal
        id="edit-list-details-modal"
        title="Edit List Details"
        :visible="isEditListDetailsModalShown"
        @hide="isEditListDetailsModalShown = false"
        scrollable
        hide-footer
        no-close-on-backdrop>
      <div class="input-container">
        <b-row>
          <b-col>
            <label class="input-title">List name</label>
            <b-form-input
                type="text"
                :state="informationValidation.isPersonalListNameProvided"
                v-model="currentToDoListName"></b-form-input>

            <b-form-invalid-feedback v-if="!informationValidation.isPersonalListNameProvided">
              This field must not be empty.
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </div>
      <div class="input-container">
        <b-row>
          <b-col>
            <label class="input-title">List description (optional)</label>
            <b-form-input
                type="text"
                v-model="currentToDoListDescription"></b-form-input>
          </b-col>
        </b-row>
      </div>
      <hr>
      <b-button class="main-input-button" block @click="updateListDetails">Update list details</b-button>
    </b-modal>

    <!-- List Options Modal -->
    <b-modal
        id="delete-list-modal"
        title="Delete List"
        :visible="isDeleteListModalShown"
        @hide="isDeleteListModalShown = false"
        @ok="deleteList"
        scrollable
        ok-only
        ok-title="Delete list"
        ok-variant="danger"
        no-close-on-backdrop>
      <p class="task-option-modal-text">Are you sure do you want to delete "<strong>{{ listDetails.toDoListName
        }}</strong>"?</p>
    </b-modal>

  </div>
</template>

<script>
  import router from "../../../router";
  import {required} from "vuelidate/lib/validators";
  import {db, storage} from "../../../main";
  import firebase from "firebase";

  export default {
    name: "PersonalListCell",
    props: {
      listDetails: Object
    },
    data() {
      return {
        currentToDoListName: this.listDetails.toDoListName,
        currentToDoListDescription: this.listDetails.toDoListDescription,
        isListOptionsButtonShown: false,
        isEditListDetailsModalShown: false,
        isDeleteListModalShown: false,
        informationValidation: {
          isPersonalListNameProvided: null
        }
      }
    },
    validations: {
      currentToDoListName: {
        required
      }
    },
    methods: {
      deleteList() {
        // clear the documents in the sub-collection before deleting the sub-collection
        this.deleteTask()

        db
          .collection('personal_to_do_lists')
          .doc(this.listDetails.toDoListId)
          .delete()

        db.collection('users')
          .doc(this.$store.getters.user.data.id)
          .update('personalToDoListOwned', firebase.firestore.FieldValue.arrayRemove(this.listDetails.toDoListId))
      },
      deleteTask() {
        // delete image attached to the task before deleting the list
        this.deleteAttachment()

        db
          .collection('personal_to_do_lists/' + this.listDetails.toDoListId + '/tasks')
          .where('toDoListId', '==', this.listDetails.toDoListId)
          .onSnapshot(querySnapshot => {
            querySnapshot.docs.map(doc => doc.ref.delete())
          })

      },
      deleteAttachment() {
        db
          .collectionGroup('tasks')
          .where('toDoListId', '==', this.listDetails.toDoListId)
          .onSnapshot(querySnapshot => {
            const taskObject = querySnapshot.docs.map(doc => doc.data())

            taskObject.forEach(task => {
              const attachmentObject = task.attachment

              if (attachmentObject !== null) {
                const attachment = task.attachment.toString()
                const attachmentRef = storage.refFromURL(attachment)

                attachmentRef.delete()
              }
            })
          })
      },
      updateListDetails() {
        // check if all information is valid
        let isValid = true

        if (!this.$v.currentToDoListName.required) {
          this.informationValidation.isPersonalListNameProvided = false
          isValid = false
        } else {
          this.informationValidation.isPersonalListNameProvided = true
        }

        if (isValid) {
          db
            .collection('personal_to_do_lists')
            .doc(this.listDetails.toDoListId)
            .update({
              toDoListName: this.currentToDoListName,
              toDoListDescription: this.currentToDoListDescription
            })
          this.hideModal('edit-list-details-modal')
        }
      },
      navigateToPersonalTaskList() {
        this.$store.dispatch('updateListCategory', 'personalTaskList')
        router.push({name: 'Personal Task List', params: {personalListId: this.listDetails.toDoListId}})
      },
      hideModal(id) {
        this.$root.$emit('bv::hide::modal', id)
      },
    },
  }
</script>

<style scoped>
  .center-align-icon {
    text-align: center;
  }

  .list-card {
    background-color: #212441;
    color: white;
    padding: 1em;
    margin-bottom: 0.75em;
  }

  .list-name-text {
    margin-bottom: 0.5em;
    font-weight: bold;
  }

  .list-description-text {
    font-size: 0.9em;
    margin-bottom: 0;
  }

  .main-input-button {
    font-weight: bold;
    background-color: #212441;
    padding: 0.5em;
  }

  .main-input-button:hover {
    font-weight: bold;
    background-color: #FFFFFF;
    color: #212441;
    padding: 0.5em;
  }

  .task-option-button {
    display: block;
  }

  .task-option-button:hover {
    cursor: pointer;
  }

  .input-container {
    margin-bottom: 1em;
  }

  .input-title {
    font-weight: bold;
  }
</style>
